<template>
  <b-modal
    id="modal-discount"
    :title="$t('message.campaign_treesoft_review_modal_title')"
    :hideHeaderClose="true"
    okOnly
    size="lg">
    <div class="container p-0">
      <div class="row">
        <div class="col-md-12">
          <p class="mb-0">
            {{ $t('message.campaign_treesoft_review_content_1') }}
          </p>
          <p>
            {{ content2Message }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div
            style="border: 1px #ccc dashed;padding: 25px 0 25px 0;"
            class="text-center"
          >
            <p>
              <strong>
                {{ $t('message.campaign_treesoft_review_content_3') }}
              </strong>
            </p>
            <button
              class="btn btn-web"
              @click="$emit('onSubmit')"
            >
              {{ $t('message.campaign_treesoft_review_content_4') }}
              <i class="fas fa-external-link-alt"/>
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <!-- <p class="mb-0">
            <u>
              {{ $t('message.campaign_treesoft_review_content_5') }}
            </u>
          </p>
          <ul>
            <li style="list-style: disc;margin-left: 15px;">
              {{ $t('message.campaign_treesoft_review_content_6') }}
            </li>
            <li style="list-style: disc;margin-left: 15px;">
              {{ $t('message.campaign_treesoft_review_content_7') }}
            </li>
          </ul> -->
          <p>
            {{ $t('message.campaign_treesoft_review_content_8') }}
          </p>
          <p>
            {{ $t('message.campaign_treesoft_review_content_9') }}
          </p>
        </div>
      </div>
    </div>
    <template #modal-footer="{ ok }">
      <div class="footer">
        <button
          class="btn btn-light"
          @click="() => ok()"
        >
          {{ $t('button.close') }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      shopInfo: 'getShopInfo',
    }),
    isCompany() {
      try {
        return this.shopInfo.info.business.form_id === 2
      } catch (err) {
        return false
      }
    },
    content2Message() {
      return this.isCompany
        ? this.$t('message.campaign_treesoft_review_content_2_company')
        : this.$t('message.campaign_treesoft_review_content_2_store')
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/base/BaseModalGetDiscount.vue